import { MAP_GEOMETRY_TYPE } from "Common/dictionaries/mapGeometryType";
import { Popover } from "devextreme-react/popover";
import includes from "lodash/includes";
import reject from "lodash/reject";
import some from "lodash/some";
import uniqBy from "lodash/uniqBy";
import React, { useEffect, useMemo, useState } from "react";
import TooltipContent from "./tooltipContent";
const wrapperAttr = { class: "no-popover-arrow" };
export default function Tooltip({ targetId, tooltipRef, ...other }) {
    const [data, setData] = useState(undefined);
    const [pixel, setPixel] = useState(undefined);
    useEffect(() => {
        if (tooltipRef) {
            tooltipRef.current = {
                hide: () => {
                    setData(undefined);
                    setPixel(undefined);
                },
                addData: (features, eventPixel) => {
                    if (features.length) {
                        setData(prev => uniqBy([...(prev || []), ...features], "id"));
                        setPixel(eventPixel);
                    }
                },
                removeData: (ids) => {
                    if (ids.length)
                        setData(prev => {
                            const result = reject(prev, e => includes(ids, e.id));
                            return result.length ? result : undefined;
                        });
                }
            };
        }
    }, []);
    const extraSpace = useMemo(() => {
        if (!data)
            return 0;
        const onlyPoints = !some(data, d => d.mapGeometryType !== MAP_GEOMETRY_TYPE.POINT);
        return onlyPoints ? (data.length > 1 ? 15 : 20) : 5;
    }, [data]);
    const position = useMemo(() => pixel
        ? {
            at: "left top",
            my: "bottom",
            offset: `${pixel[0]} ${pixel[1] - extraSpace}`,
            of: `#${targetId}`,
            collision: "fit flip"
        }
        : undefined, [extraSpace, pixel]);
    if (!(data === null || data === void 0 ? void 0 : data.length) || !position)
        return null;
    return (React.createElement(Popover, { wrapperAttr: wrapperAttr, target: `#${targetId}`, container: `#${targetId}`, defaultVisible: true, visible: true, position: position, showTitle: false, contentRender: () => React.createElement(TooltipContent, { ...other, features: data }), deferRendering: false, hideOnParentScroll: true, hideOnOutsideClick: true }));
}
Tooltip.defaultProps = {
    textMaxLength: 120
};
